import React, { PropTypes } from 'react';
import classnames from 'classnames';
import EmailSubscriptionForm from 'landing_pages/components/email_subscription_form';
import EmailSubscriptionForm2 from 'landing_pages/components/email_subscription_form_2';
import { trackGoogle, trackFacebookCustomEvent } from 'common/tracking';

const trackSubscription = (action, label) => {
  trackGoogle("subscribed_email", action, label);
  trackFacebookCustomEvent("1726897664301628", "subscribed_email", {
    "where": "landing_hero",
    "label": label
  });
}

const SubscriptionHero2 = ({
  image, title, subtitle, security_code, submit_label, promo, className, formTitle,
  formClassName, background="#000630", showSingleNameField, hideNameFields, notice, intercomTag,
  pageUrlStem, successTitle, blockType, action_url, imageSide="left", titleCentered
}) => {

  const Form = intercomTag? EmailSubscriptionForm2 : EmailSubscriptionForm;

  return (
    <section className={classnames('block block-subs-hero-2', className)}
        style={{ background }} id="subs_hero">
      { titleCentered &&
      <div className="row columns">
        <div className="block-header">
          <h2 className="title">{ title }</h2>
        </div>
      </div> }
      <div className="row align-center align-middle">
        <div className={classnames("column small-16 large-7", { "large-order-2": imageSide === 'right' })}>
          <img src={image.url} alt={image.alt} />
        </div>
        <div className={classnames("column small-16 large-7", { "large-order-1": imageSide === 'right' })}>
          { !titleCentered && <h1 className="title">{ title }</h1> }
          <div className="subtitle" dangerouslySetInnerHTML={{ __html: subtitle }} />
          <Form
            fullWidth={true}
            action_url={action_url}
            security_code={security_code}
            submit_label={submit_label}
            callback={trackSubscription.bind(null, blockType, (intercomTag || title).toLowerCase())}
            promo={promo}
            className={formClassName}
            background={background}
            showSingleNameField={showSingleNameField}
            hideNameFields={hideNameFields}
            notice={notice}
            pageUrlStem={pageUrlStem}
            intercomTag={intercomTag}
            formTitle={formTitle}
            successTitle={successTitle}
          />
        </div>
      </div>
    </section>
  );
}

SubscriptionHero2.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.object.isRequired,
  className: PropTypes.string,
  formClassName: PropTypes.string,
  formTitle: PropTypes.string,
  background: PropTypes.string,
  notice: PropTypes.string,
  security_code: PropTypes.string,
  submit_label: PropTypes.string,
  promo: PropTypes.string,
  showSingleNameField: PropTypes.bool,
  hideNameFields: PropTypes.bool,
  intercomTag: PropTypes.string,
  pageUrlStem: PropTypes.string.isRequired,
  successTitle: PropTypes.string,
  blockType: PropTypes.string.isRequired,
  action_url: PropTypes.string,
  imageSide: PropTypes.string,
  titleCentered: PropTypes.bool,
};

export default SubscriptionHero2;



// WEBPACK FOOTER //
// ./landing_pages/components/subscription_hero_2.jsx